var _ = require('underscore');
var TorsoCollection = require('backbone-torso/modules/Collection');
var InsuranceEstimationModel = require('./InsuranceEstimationModel');
var insuranceEstimationExtService = require('./../urls').insuranceEstimationExtService;

/**
 * Receives insurance estimations from the InsuranceEstimationExtService which serves the InsuranceEstimationDTO resource
 * @class InsuranceEstimationCollection
 * @static
 * @extends Torso.Collection
 */
module.exports = new (TorsoCollection.extend({
  model: InsuranceEstimationModel,
  url: insuranceEstimationExtService,
  fetchHttpAction: 'POST',

  /**
   * Fetch a list of account ids by criteria
   * @method fetchIdsByCriteria
   * @param criteria {String} criteria suitable for the insuranceEstimationExtService
   * @return A Promise wrapping a list of ids
   */
  fetchIdsByCriteria : function(criteria) {
    return $.ajax({
      url: insuranceEstimationExtService + '/ids/criteria',
      contentType: 'application/json',
      type: 'POST',
      dataType: 'json',
      data: JSON.stringify(criteria)
    });
  },

  /**
   * Get the insurance estimation by it's account number.
   * @method getByAccountNumber
   * @param accountNumber {String} the account number to get the insurance estimation by.
   * @return {InsuranceEstimationModel}
   */
  getByAccountNumber: function(accountNumber) {
    return this.findWhere({ accountNumber: accountNumber });
  },

  /**
   * @method setAccountNumbersToSortBy
   * @param accountNumbers {String[]|String} the account number(s) to promote to the top of the list.
   */
  setAccountNumbersToSortBy: function(accountNumbers) {
    if (!_.isArray(accountNumbers)) {
      accountNumbers = [accountNumbers];
    }
    this._accountNumbers = accountNumbers;
    this.sort();
  },

  /**
   * Sorts payable bills, selected item first, then the rest in descending order by account number.
   * @method comparator
   * @override
   * @param firstInsuranceEstimationModel {Object} one model to compare (lhs)
   * @param secondInsuranceEstimationModel {Object} the other model to compare (rhs)
   */
  comparator: function(firstInsuranceEstimationModel, secondInsuranceEstimationModel) {
    var comparatorValue;

    var firstEstimationAccountNumber = firstInsuranceEstimationModel.get('accountNumber');
    var secondEstimationAccountNumber = secondInsuranceEstimationModel.get('accountNumber');
    if (_.contains(this._accountNumbers, firstEstimationAccountNumber)) {
      comparatorValue = -1;
    } else if (_.contains(this._accountNumbers, secondEstimationAccountNumber)) {
      comparatorValue = 1;
    } else {
      if (firstEstimationAccountNumber < secondEstimationAccountNumber) {
        comparatorValue = 1;
      } else if (firstEstimationAccountNumber > secondEstimationAccountNumber) {
        comparatorValue = -1;
      } else {
        comparatorValue = 0;
      }
    }
    return comparatorValue;
  }
}))();
